export enum Instance {
    App,
    La28,
}
